// extracted by mini-css-extract-plugin
export default {"card":"left-card_card__PXu8A"};